module.exports = __webpack_public_path__ + "img/quitar.6e6914a4.svg";